import { render } from "./blood-pressure.vue?vue&type=template&id=6d1f2da4&scoped=true"
import script from "./blood-pressure.vue?vue&type=script&lang=js"
export * from "./blood-pressure.vue?vue&type=script&lang=js"

import "./blood-pressure.vue?vue&type=style&index=0&id=6d1f2da4&scoped=true&lang=css"

import exportComponent from "/Users/qmaura/PANOPTIC/lify-blends-recommender/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d1f2da4"]])

export default __exports__